import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  AdminSandboxUserLookupDto,
  SandboxCreatorSearchResponse,
  SandboxUserAccessDto,
} from '../molecules/sandbox-user-config/sandbox-user.types';

@Injectable({
  providedIn: 'root',
})
export class AdminSandboxUserService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  getUser(firebaseUid: string): Observable<AdminSandboxUserLookupDto> {
    return this.http.get<AdminSandboxUserLookupDto>(`${this.api}/users/${firebaseUid}`);
  }

  getSandboxAccess(firebaseUid: string): Observable<SandboxUserAccessDto | null> {
    return this.http.get<SandboxUserAccessDto | null>(
      `${this.api}/users/sandbox-access/${firebaseUid}`,
    );
  }

  setSandboxUserFlag(firebaseUid: string, enabled: boolean): Observable<unknown> {
    return this.http.patch(`${this.api}/users/sandbox-user`, { firebaseUid, enabled });
  }

  updateSandboxAccess(
    firebaseUid: string,
    access: SandboxUserAccessDto,
  ): Observable<SandboxUserAccessDto> {
    return this.http.patch<SandboxUserAccessDto>(`${this.api}/users/sandbox-access`, {
      firebaseUid,
      ...access,
    });
  }

  searchCreators(searchTerm: string): Observable<SandboxCreatorSearchResponse> {
    return this.http.post<SandboxCreatorSearchResponse>(
      `${this.api}/creators/filter/v2`,
      {
        searchTerm: searchTerm.trim(),
        take: 25,
        skip: 0,
      },
    );
  }
}
